module.exports = __webpack_public_path__ + "static/media/texture (0).51fd3f60.jpg";